export default {
	optionRow: { 
		display: 'flex', 
		width: '50%'
	},
	optionLeftColumn: { 
		flex: 1 
	},
	optionRightColumn: { 
		flex: 2, 
		display: 'flex' 
	},
	fullWidthButton: { 
		width: '80%', 
		marginLeft: 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '30px'
	},
	red: {
		color: '#ff4400'
	},
	body: {
		display: 'flex', 
		flexDirection: 'column', 
		gap: '40px', 
		marginTop: '20px'
	},
	linkDiv: {
		display: 'flex', 
		alignItems: 'center', 
		gap: '10px', 
		cursor: 'pointer',
	},
	linkBlue: {
		color: 'mediumslateblue'
	}
}